<template>
  <div>
    <ed-email :intCabecalhoMovimentoId="$route.params.intId" :intMovimentoId="$route.params.intMovimentoId" :intTipoMovimentoId="1443" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmail from "@/components/movimento/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmail },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "financeiro.receita.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>